// Publieke, niet-geheime configuratie voor de widget in de browser. Nooit
// geheime sleutels hier plaatsen - alleen waarden die sowieso zichtbaar zijn
// in het netwerkverkeer (zoals een Turnstile site key, die per ontwerp
// publiek is).

type PublicEnvKey =
  | "VITE_API_BASE_URL"
  | "VITE_TURNSTILE_SITE_KEY"
  | "VITE_ALLOWED_PARENT_ORIGINS"
  | "VITE_PRIVACY_POLICY_URL";

function readEnv(key: PublicEnvKey, fallback: string): string {
  const value: string | undefined = import.meta.env[key];
  return typeof value === "string" && value.length > 0 ? value : fallback;
}

export const publicEnv = {
  /** Basis-URL van de API. Leeg laten wanneer de widget op hetzelfde domein draait. */
  apiBaseUrl: readEnv("VITE_API_BASE_URL", ""),

  /** Cloudflare Turnstile site key (publiek, geen geheim). */
  turnstileSiteKey: readEnv("VITE_TURNSTILE_SITE_KEY", "1x00000000000000000000AA"),

  /**
   * Toegestane parent-origins voor window.postMessage vanuit de Webflow-
   * embed. Kommagescheiden lijst. Nooit "*" gebruiken.
   */
  allowedParentOrigins: readEnv(
    "VITE_ALLOWED_PARENT_ORIGINS",
    "https://demomentmaker.nl,https://www.demomentmaker.nl,https://demomentmaker.webflow.io",
  )
    .split(",")
    .map((origin) => origin.trim())
    .filter(Boolean),

  privacyPolicyUrl: readEnv(
    "VITE_PRIVACY_POLICY_URL",
    "https://demomentmaker.nl/privacyverklaring",
  ),
};
